export const getContactsBinPageNextjsUrl = () => '/contacts/bin'
